import React, { Component } from 'react';
import category from '../../../data/jobs/category.json';
import { Link } from 'react-router-dom';

class Category extends Component {
    render() {
        return (
            <section className="section-padding section our-work-sec bg-light-white">
                <div className="container">
                    <div className="section-header text-center">
                        <div className="section-heading">
                            <h3 className="text-custom-black">Our <span className="text-custom-blue">Category</span></h3>
                            <div className="section-description">
                                <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {/* Data */}
                        {category.map((item, i) => (
                            <div className="col-lg-3 col-md-6" key={i}>
                                <div className="catagri-item"> <i className={item.icon} /> <Link to={"/jobs/cat/" + item.id}>{item.title}</Link> </div>
                            </div>
                        ))}
                        {/* Data */}
                    </div>
                </div>
            </section>
        );
    }
}

export default Category;